import React from "react";
import Maquiagem from './icons/maquiagem.jpg';
import NailDesigner from "./icons/fotodestaquemanicure.jpg";
import Afiacao from './icons/afiacaobg.jpg';
import SobreBG from './icons/FOTO2.jpg';
import VagaSocial from './icons/vagasocial.png';
import CapaBrow from './icons/CAPABROW.png';
import '../styles/HeroSlider.css';
import Flickity from 'react-flickity-component';

const flickityOptions = {
    wrapAround: true,
    autoPlay: 6000, // Mudar slide a cada 6 segundos
    pauseAutoPlayOnHover: false, // Não pausar no hover
    prevNextButtons: true,  // Habilitar botões de navegação
    contain: true, 
    initialIndex: 1
};

const HeroSlider = () => {
    const slides = [        
        { image: VagaSocial, header: "Vagas sociais disponíveis!", text: "Matrículas Abertas", link: "https://api.whatsapp.com/send?phone=5519978167330&text=Olá!%20Eu%20gostaria%20de%20me%20inscrever%20para%20as%20vagas%20sociais!.", buttonText: "Entrar em contato!" },
        { image: Maquiagem , header: "Maquiagem Profissional", text: "Lançamento!", link: "https://academiagirassol.hotmart.host/maquiagem-profissional", buttonText: "Saiba mais!" },
        { image: NailDesigner, header: "Manicure e Pedicure", text: "Design em Unhas", link: "https://academiagirassol.hotmart.host/nail-designer", buttonText: "Saiba mais!" },
        { image: CapaBrow, header: "Design em Sobrancelhas", text: "Brow Designer", link: "https://academiagirassol.hotmart.host/brow-designer", buttonText: "Saiba mais!" },
        { image: SobreBG, header: "Sobre Nossa", text: "Escola", link: "#sobre", buttonText: "Conheça-nos!" },
        { image: Afiacao, header: "Serviço Especializado", text: "Afiação de Alicates", link: "https://abrir.link/BOhfx", buttonText: "Solicitar orçamento!" },
    ];

    return (
        <Flickity className={'hero-slider'} elementType={'div'} options={flickityOptions} reloadOnUpdate>
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className="carousel-cell"
                    id="hero-slider"
                    style={{ backgroundImage: `url(${slide.image})`, backgroundColor: '#f4f4f4', backgroundSize: 'cover', backgroundPosition: 'center' }}
                >
                    <div className="info-container">
                        {slide.header && <h3 className="header">{slide.header}</h3>}
                        <h2 className="text">{slide.text}</h2>
                        {slide.link.startsWith('#') ? (
                            <a href={slide.link}>
                                <button>{slide.buttonText}</button>
                            </a>
                        ) : (
                            <a href={slide.link} target="_blank" rel="noreferrer">
                                <button>{slide.buttonText}</button>
                            </a>
                        )}
                    </div>
                </div>
            ))}
        </Flickity>
    );
};

export default HeroSlider;
